
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gfwv3_1exu9_99",
  "horizontal": "awsui_horizontal_gfwv3_1exu9_104",
  "vertical": "awsui_vertical_gfwv3_1exu9_108",
  "list": "awsui_list_gfwv3_1exu9_112",
  "list-item": "awsui_list-item_gfwv3_1exu9_132",
  "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_1exu9_139",
  "toggle": "awsui_toggle_gfwv3_1exu9_139",
  "description": "awsui_description_gfwv3_1exu9_235",
  "separator": "awsui_separator_gfwv3_1exu9_239"
};
  